var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zone-progress-bar"},[_c('div',{staticClass:"progressbar"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:step.number,staticClass:"element",class:{
        'small': step.small,
        'filled': _vm.currentStep >= i + 1,
        'inactive': ((i + 1 === 3 || i + 1 === 4) && _vm.noSolidFuel) || (i + 1 === 6 && _vm.addressIsSame)
      }},[_c('div',{staticClass:"dot"},[_vm._v("\n        "+_vm._s(step.number)+"\n      ")]),_c('label',{staticClass:"d-none d-md-flex"},[_vm._v("\n        "+_vm._s(step.title)+"\n      ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }